import { HttpBackend, HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { finalize, map, shareReplay, tap } from "rxjs/operators";
import { environment } from "environments/environment";
import { AuthHttpConfig } from "./auth-http-config";

interface RefreshTokenResponse {
  token: string;
  refresh_token: string;
}

@Injectable({ providedIn: "root" })
export class TokenRefreshService {
  private authHttpConfig = inject(AuthHttpConfig);
  // HttpBackend skips the interceptors, so a 401 here cannot trigger another refresh.
  private httpClient = new HttpClient(inject(HttpBackend));
  private inFlight: Observable<string> = null;

  /** Exchanges the stored refresh token for a new JWT; concurrent callers share one request. */
  public refresh(): Observable<string> {
    if (this.inFlight === null) {
      this.inFlight = this.httpClient
        .post<RefreshTokenResponse>(`${environment.apiUrl}/token/refresh`, {
          refresh_token: this.authHttpConfig.getRefreshToken(),
        })
        .pipe(
          tap((response) => {
            this.authHttpConfig.setToken(response.token);
            this.authHttpConfig.setRefreshToken(response.refresh_token);
          }),
          map((response) => response.token),
          finalize(() => (this.inFlight = null)),
          shareReplay(1),
        );
    }

    return this.inFlight;
  }
}
